(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('selectOeeState', {
        templateUrl: 'views/components/views/selectOeeState/selectOeeState.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'selectOeeStateService', function ($stateParams, selectOeeStateService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let arrowSide = $stateParams.arrowside
            
            vm.model = {
                arrowSide: arrowSide,
                itemsListSelectOeeStates: []
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region LOAD PROCEDURE FUNCTION CALL

            async function loadSelectOeeStates() {
                vm.model.itemsListSelectOeeStates = await selectOeeStateService.listSelectOeeStates();
            }

            // #endregion LOAD PROCEDURE FUNCTION CALL

            // #region SAVE & DIRECTION FUNCTION

            vm.goToPage = function (item) {
                selectOeeStateService.savingToPreP2SelectOeeState = true;

                selectOeeStateService.saveToPage({ oeestate_keyno: item.item_id });
            }

            // #endregion SAVE & DIRECTION FUNCTION

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                loadSelectOeeStates();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
